module.exports = __webpack_public_path__ + "media/images/upload-example-1-e752ecf1bcf8616bf5ad3623a16d64ce.png";